import Reveal from "@/components/base/Reveal";
import { downloadData } from "@/mocks/homeData";

type DownloadSectionProps = {
  onAction: (message: string) => void;
};

const toneStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function DownloadSection({ onAction }: DownloadSectionProps) {
  return (
    <section id="download" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.2em] text-secondary-600">DOWNLOAD</span>
          <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            下载入口 · 把全记录带走
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            挑一种顺手的格式导出，离线、转发、存档都不受限制。所有文件都来自同一份已核对的节点库。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {downloadData.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <button
                type="button"
                onClick={() => onAction(`「${item.title}」（${item.format}）下载已开始（演示）`)}
                className="group flex h-full w-full cursor-pointer flex-col rounded-lg border border-background-200/80 bg-background-50 p-6 text-left transition-transform hover:-translate-y-1"
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-md ${toneStyles[item.tone] ?? toneStyles.primary}`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h4 className="mt-5 font-heading text-base font-bold text-foreground-950">{item.title}</h4>
                <p className="mt-2 text-sm text-foreground-600">{item.desc}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-xs tracking-[0.12em] text-foreground-500">
                    {item.format} · {item.size}
                  </span>
                  <span className="flex h-6 w-6 items-center justify-center text-primary-600 transition-transform group-hover:translate-y-0.5">
                    <i className="ri-download-2-line text-lg"></i>
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8">
          <div className="flex flex-col items-start gap-5 rounded-lg border border-primary-200 bg-primary-50 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div className="flex items-start gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-folder-zip-line text-2xl"></i>
              </span>
              <div>
                <h4 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  打包下载全部格式
                </h4>
                <p className="mt-2 text-sm text-foreground-600">
                  PDF + 长图 + 速查表 + 课代表卡片，一次导出，共 24.3 MB。
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => onAction("全部格式打包下载已开始（演示）")}
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:w-auto"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-cloud-2-line text-base"></i>
              </span>
              下载全部
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}